<template>
  <div id="app" class="h-100" :class="[skinClasses]">
    <component :is="layout">
      <router-view />
    </component>
    <!-- <ChatBox v-if="showChatBox" ref="chatBox" /> -->
  </div>
</template>

<script>
import { $themeColors, $themeBreakpoints, $themeConfig } from "@themeConfig";
import { provideToast } from "vue-toastification/composition";
import { watch } from "@vue/composition-api";
import useAppConfig from "@core/app-config/useAppConfig";
// import ChatBox from "./components/silvIA/ChatBox.vue";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useWindowSize, useCssVar } from "@vueuse/core";
import store from "@/store";
import storeUser from '@/store/user';


const LayoutVertical = () => import("@/layouts/vertical/LayoutVertical.vue");
const LayoutHorizontal = () => import("@/layouts/horizontal/LayoutHorizontal.vue");
const LayoutFull = () => import("@/layouts/full/LayoutFull.vue");

export default {
  components: {
    LayoutHorizontal,
    LayoutVertical,
    LayoutFull,
    // ChatBox,
  },
  data() {
    return {
      isLoginPage: false,
      isErrorPage: false,
    };
  },
  watch: {
    "$route"(to) {
      this.checkIfLoginPage();
      this.checkIfErroPage();
    },
  },
  created() {
    this.checkIfLoginPage();
    this.checkIfErroPage();
  },
  computed: {
    layout() {
      if (this.$route.meta.layout === "full") return "layout-full";
      return `layout-${this.contentLayoutType}`;
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type;
    },
  },
  methods: {
    checkIfLoginPage() {
      this.isLoginPage = this.$route.name === "login" || this.$route.path === "/login";
    },
    checkIfErroPage() {
      this.isErrorPage = this.$route.name === "error404" || this.$route.path === "/error-404";
    },
    // showChatBox() {
    //   // Verifica se a permissão 126 está presente e não está na página de login ou erro
    //   const permissions = store.state.user.data.profile.permissions || [];
    //   return permissions.includes(126) && !this.isLoginPage && !this.isErrorPage;
    // },
  },
  beforeCreate() {
    // Configuração de cores e breakpoints do tema
    const colors = ["primary", "secondary", "success", "info", "warning", "danger", "light", "dark"];
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(`--${colors[i]}`, document.documentElement).value.trim();
    }

    const breakpoints = ["xs", "sm", "md", "lg", "xl"];
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(
        useCssVar(`--breakpoint-${breakpoints[i]}`, document.documentElement).value.slice(0, -2)
      );
    }

    const { isRTL } = $themeConfig.layout;
    document.documentElement.setAttribute("dir", isRTL ? "rtl" : "ltr");
  },
  setup() {
    const { skin, skinClasses } = useAppConfig();

    if (skin.value === "dark") document.body.classList.add("dark-layout");

    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 9000,
      transition: "Vue-Toastification__fade",
    });

    store.commit("app/UPDATE_WINDOW_WIDTH", window.innerWidth);
    const { width: windowWidth } = useWindowSize();
    watch(windowWidth, (val) => {
      store.commit("app/UPDATE_WINDOW_WIDTH", val);
    });

    return {
      skinClasses,
    };
  },
};
</script>
